<template>
  <div class="CCBImages">
    <v-container fluid fill-height>
      <v-layout
        justify-center
        align-center
      >
        <v-flex md6>
          <v-card class="mb-2">
            <v-card-title class="title">
              Imágenes CCB
              <v-spacer/>
              <v-card-actions>
                <v-btn color="info" :disabled="loading">
                  <download-csv
                    :data="dataVals"
                    :name="'Imagen Relacionada a Encuesta.csv'"
                    :labels="labels"
                    :fields="fields"
                  >
                    <v-icon left style="vertical-align: middle">cloud_download</v-icon>csv
                  </download-csv>
                </v-btn>
              </v-card-actions>
            </v-card-title>

            <v-card-text v-if="!loading && dataVals.length !== 0">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details
              ></v-text-field>
            </v-card-text>

            <v-card-text
              v-if="loading"
              class="text-xs-center"
            >
              <v-progress-circular
                :size="progressSize"
                :width="progressWidth"
                :value="completed"
                color="info"
              >
                {{ progressAdvance }}
                {{ progressTotal }}
              </v-progress-circular>
            </v-card-text>

            <v-card-text v-else>
              <v-data-table
                dense
                :headers="headers"
                :items="dataVals"
                :search="search"
                no-results-text="No se encontro el término buscado"
                no-data-text="No hay datos disponibles"
                multi-sort
                class="elevation-1"
                loading="Cargando... Por favor espere."
                rows-per-page-text="Filas por página:"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.dir }}</td>
                  <td>{{ props.item.incidencia }}</td>
                  <td class="justify-center layout px-0">
                    <v-icon
                      color="info"
                      class="mr-2"
                      @click="getItem(props.item)"
                    >
                      camera_alt
                    </v-icon>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>

            <v-dialog
              v-model="dialog"
              max-width="600px"
            >
              <v-card>
                <v-card-title>
                  <span class="headline"> Imágen Relacionada: <br> </span>
                  <v-spacer/>
                  <v-btn color="info" @click="close">Cerrar</v-btn>
                </v-card-title>

                <v-card-text>
                  <b>Dirección: </b> {{ itemDir }} <br>
                  <b>Incidencia: </b> {{ itemInc }}
                </v-card-text>

                <v-divider />

                <v-img
                  contain
                  :src="itemImg"
                  :key="imageKey"
                >
                </v-img>
              </v-card>
            </v-dialog>

          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import JsonCSV from 'vue-json-csv'

export default {
  name: 'CCBImages',

  /**
   * Esta función carga el respectivo Layout, al crear la vista.
   */
  created () {
    this.$store.commit('SET_LAYOUT', 'dashboard-layout')
    this.loadImages()
  },

  components: {
    'download-csv': JsonCSV
  },

  data: function () {
    return {
      backConf: {
        path: '/ccb/images?page=',
        page: 1
      },

      search: '',
      dialog: false,
      loading: false,
      progressSize: 70,
      progressWidth: 7,
      progressTotal: 0,
      progressAdvance: 0,
      completed: 0,

      itemImg: null,
      itemDir: null,
      itemInc: null,
      imageKey: 0,

      tableKey: 0,

      headers: [
        {
          text: 'Dirección Encuesta',
          align: 'left',
          value: 'dir'
        },
        {
          text: 'Incidencia',
          value: 'incidencia'
        },
        {
          text: 'Ver',
          sortable: false
        }
      ],

      labels: {
        id: 'Identificador Encuesta',
        dir: 'Dirección Encuesta',
        incidencia: 'Incidencia de la encuesta',
        url_image: 'Url de la imagen'
      },
      fields: ['id', 'dir', 'incidencia', 'url_image'],

      dataVals: []
    }
  },

  computed: {},

  watch: {
    dialog (val) {
      val || this.close()
    },

    'dataVals': function () {
      this.completed = (this.progressAdvance / this.progressTotal) * 100
    }
  },

  methods: {
    /**
     * Carga la tabla con todos los audios
     */
    loadImages () {
      this.loading = true
      let request = {
        method: 'get',
        params: {},
        url: this.backConf.path + this.backConf.page
      }

      let t = this
      this.$store.dispatch('request_back', request)
        .then(function (resp) {
          t.progressTotal = resp.data.count
          t.progressAdvance = t.dataVals.length

          t.dataVals = t.dataVals.concat(resp.data.results)
          if (resp.data.next !== null) {
            t.backConf.page += 1
            t.loadImages()
          } else {
            t.backConf.page = 1
            t.loading = false
          }
        })
        .catch(function (err) {
          t.data = []
          t.loading = false
          console.error(err)
        })
    },

    getItem (item) {
      this.dialog = true
      this.itemImg = item.url_image
      this.itemDir = item.dir
      this.itemInc = item.incidencia
      this.imageKey += 1
    },

    close () {
      this.dialog = false
      this.itemImg = null
      this.itemDir = null
      this.itemInc = null
    }
  }
}
</script>
